import axiosModule, { AxiosInstance, AxiosRequestConfig } from 'axios'

import { EditReceiptApiCommand, ReceiptListView } from '../../contracts/review/AdminReviewReceipt'

const NO_RECEIPTS_CODE = 404

export class AdminApiReview {
  constructor(private axios: AxiosInstance) {}

  getReceiptList = async (reviewId: number): Promise<ReceiptListView | null> => {
    const config: AxiosRequestConfig = {
      url: '/review/query/admin/get-receipt-review-list-views/process',
      method: 'post',
      data: {
        reviewId,
      },
    }

    try {
      const { data } = await this.axios.request<ReceiptListView>(config)

      return data
    } catch (error: unknown) {
      return this.handleGetReceiptListError(error)
    }
  }

  private handleGetReceiptListError = (error: unknown): null => {
    if (axiosModule.isAxiosError(error) && error.response?.status === NO_RECEIPTS_CODE) {
      return null
    }
    throw error
  }

  editReceipt = async (params: EditReceiptApiCommand): Promise<void> => {
    const config: AxiosRequestConfig = {
      url: '/review/command/admin/edit-receipt/execute',
      method: 'post',
      data: params,
    }

    await this.axios.request(config)
  }
}
